import { AssessmentAnswerInput, SectionName } from '../../generated/graphql';
import { clearAssessmentResponse } from '../api-wrappers';
import { MedicalInfoAnswers } from '../types';

export const formatAnswersForState = answers => {
  const answersForStore = {};
  answers.forEach(ans => {
    answersForStore[ans.questionCode] = ans.answerValue;
  });
  return answersForStore;
};

export const formatAnswersForBackend = (answers): AssessmentAnswerInput[] =>
  answers.map(ans => {
    const { questionCode, answerValue } = ans;
    if (Array.isArray(answerValue)) {
      const joinedAnswerValue = answerValue
        .map(it => (typeof it === 'string' ? it : it.value))
        .join('|');
      return { questionCode, answerValue: joinedAnswerValue };
    }
    return ans;
  });

export const getAssessmentSection = (questionCode: string) => {
  if (questionCode.startsWith('RV_')) return SectionName.ReasonVisit;
  if (questionCode.startsWith('MI_')) return SectionName.MedicalInfo;
  return null;
};

export const isPlanOutOfNetwork = (
  plan: MedicalInfoAnswers['MI_InsurancePlan']
) => /out-of-network$/.test(plan && plan[0]);

export const hasOtherPlan = (
  plan: MedicalInfoAnswers['MI_InsurancePlan'] | string
) => {
  const planStr = Array.isArray(plan) ? plan[0] : plan;
  return /^Other/.test(planStr);
};

export const clearInsuranceResponses = async () => {
  const insQs = ['MI_InsuranceProvider', 'MI_InsurancePlan', 'MI_InsuranceId'];
  const responses = await Promise.all(
    insQs.map(async questionCode =>
      clearAssessmentResponse({
        section: SectionName.MedicalInfo,
        questionCode,
      })
    )
  );

  const errors = responses.filter(res => res.errors);
  if (errors.length) return errors;
};
